import { FC, useContext } from 'react'

import { HEALTH_CHECK } from '../../../utils/constants/Enums'
import { AppContext } from 'providers/context/App'
import {
  facialPreCheck,
  laserPreCheck,
  microPreCheck,
} from 'utils/constants/Helpers'

import './health-check.scss'

interface Props {
  healthCheck: HEALTH_CHECK
}

const HealthCheckContent: FC<Props> = ({ healthCheck }) => {
  const { appMasterData } = useContext(AppContext)
  const isLaserFacial = appMasterData.isLaserFacial
  const isMicroNeedling = appMasterData.isMicroNeedling
  const checkInList = isLaserFacial
    ? laserPreCheck
    : isMicroNeedling
      ? microPreCheck
      : facialPreCheck

  return (
    <div className="content-wrapper health-check-content">
      <label className="head-label">PRE-FACIAL check-in</label>
      {healthCheck === HEALTH_CHECK.YES ? (
        <>
          <h3>{checkInList.chooseHeader} </h3>
          <p>{checkInList.chooseContent}</p>
          {checkInList.chooseContentBottom && (
            <p>{checkInList.chooseContentBottom}</p>
          )}
        </>
      ) : (
        <>
          <h3>
            Almost there! ✨ <br /> {checkInList.header}
          </h3>
          <ul className="facialCheckList">
            {checkInList.items.map((item) => (
              <li key={`checkList-${item}`} data-testid="list-item">
                {item}
              </li>
            ))}
          </ul>
          {checkInList.note && (
            <p>
              <strong>{checkInList.note}</strong>
            </p>
          )}
          <p>
            {!isMicroNeedling && 'If so, sit tight!'}
            <strong>{checkInList.footer}</strong>
          </p>
        </>
      )}
    </div>
  )
}

export default HealthCheckContent
